import React, { Component } from 'react';
import { Button, Icon, message, Table, Upload, Tag } from 'antd';
import config from '../../config';
import SsoApi from '../../api/SsoApi';
import { contactsFromFileColumns } from './columns/contactsFromFileColumns';
import TEXTS from '../../locale/texts';

class AddMsisdnsFromFile extends Component {
  state = {
    tableData: [],
    message: '',
    isLoading: true,
    isLoadingFile: false,
    isLoadingGroups: true,
    dataFromFile: null,
    pageSize: 20,
    currentPage: 1
  };

  columns = contactsFromFileColumns.bind(this);

  uploadProps = {
    name: 'file',
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    action: `${config.smsgwMessagingUrl}/api/extract/msisdns-with-data`,
    beforeUpload: (props) => {
      const { size: bytes } = props;
      const KB = bytes / 1024;
      const MB = KB / 1024;
      if (MB > 5) {
        message.error(TEXTS.importFileTooBig[this.props.lang], 5);
        return Promise.reject();
      }
    },
    headers: {
      Authorization: `Bearer ${SsoApi.token}`,
      'X-Client-Bin': SsoApi.bin
    },
    showUploadList: false
  };

  onChangeUpload = (info) => {
    const uploadingStatus = info.file.status;
    let response = info.file.response;

    if (uploadingStatus === 'uploading') {
      this.setState({ isLoadingFile: true });
    }
    if (uploadingStatus === 'done') {
      let responseMsisdns = response.msisdns;
      if (response && responseMsisdns && responseMsisdns.length > 0) {
        // id comes as null from backend for a file
        // so set temporary id for tableRow key
        responseMsisdns = responseMsisdns.map((item) => {
          return {
            ...item,
            id: parseInt(Math.random() * 100000)
          };
        });
      }
      message.success(TEXTS.importFileIsLoaded[this.props.lang], 3);
      this.setState((prevState) => ({
        dataFromFile: response
          ? [...(prevState.dataFromFile || []), ...responseMsisdns]
          : (prevState.dataFromFile || []),
        dataFromFileExtra: {
          isAscii: response.isAscii,
          maxSymbols: response.maxSymbols,
          duplicatedCount: response.duplicatedCount,
          invalidCount: response.invalidCount,
          validCount: response.validCount,
          totalCount: response.totalCount
        },
        isLoadingFile: false
      }), () => {
        this.props.updateSmsBodyMeta(this.state.dataFromFileExtra);
      });
    } else if (info.file.status === 'error') {
      this.setState({ isLoadingFile: false });
      message.error(TEXTS.importFileCouldNotLoad[this.props.lang]);
    }
  };

  onCancel = () => {
    const { hideDrawer } = this.props;
    this.setState({
      msisdns: [],
      tableData: [],
      message: ''
    });
    hideDrawer();
  };

  addToCampaign = () => {
    const { updateMsisdns, hideDrawer } = this.props;
    const { dataFromFile } = this.state;
    updateMsisdns(dataFromFile);
    hideDrawer();
  };

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({ selectedRows });
    }
  };

  render() {
    const { lang } = this.props;
    const { dataFromFile, dataFromFileExtra, isLoadingFile, pageSize, currentPage } = this.state;
    const msisdns = dataFromFile && dataFromFile.map(i => i.msisdn);
    const columns = this.columns(pageSize, currentPage, lang);
    const { totalCount, duplicatedCount, invalidCount, validCount } = dataFromFileExtra || {};

    const tableMeta = (
      <p>
        {TEXTS.importNumbersTotal[lang]}: <Tag color="blue" style={{marginRight: 3}}>{totalCount}</Tag>,{' '}
        {TEXTS.importNumbersValid[lang]}: <Tag color="green" style={{marginRight: 3}}>{validCount}</Tag>,{' '}
        {TEXTS.importNumbersInvalid[lang]}: <Tag color="red" style={{marginRight: 3}}>{invalidCount}</Tag>,{' '}
        {TEXTS.importNumbersDuplicate[lang]}: <Tag color="orange" style={{marginRight: 3}}>{duplicatedCount}</Tag>.
      </p>
    );

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="t-light">{TEXTS.titleAddReceiversFromFile[lang]}</h3>
          <div>
            {dataFromFile
              && <Button
                  type="primary"
                  size="large"
                  style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
                  onClick={this.addToCampaign}
                  disabled={msisdns.length === 0}
                 >
                   {TEXTS.btnAddMsisdn[lang]}
                 </Button>}
            <Button
              style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
              onClick={this.onCancel}>
              {TEXTS.btnCancel[lang]}
            </Button>
          </div>
        </div>

        <p>
          {TEXTS.importFileDisclaimer[lang]}{' '}
          {TEXTS.importFileDisclaimerFormat[lang]}{' '}
          <a href="https://static.kcell.kz/business/template.xlsx"
             target="_blank" rel="noopener noreferrer"
          >{TEXTS.importFileExample[lang]}</a>
        </p>

        <div className='form-row mb-4'>
          <Upload {...this.uploadProps} disabled={dataFromFile} onChange={this.onChangeUpload}>
            <Button disabled={dataFromFile} style={{height: 40}}>
              <Icon type="upload" style={{ position: 'relative', top: -4 }}/> {TEXTS.btnImportFile[this.props.lang]}
            </Button>
          </Upload>
        </div>

        {isLoadingFile && !dataFromFile
          ? <p>{TEXTS.dataIsLoading[lang]}...</p>
          : (dataFromFile && dataFromFile.length > 0
              && <>{tableMeta}<Table dataSource={dataFromFile} rowKey={({msisdn}) => msisdn} columns={columns}
                        pagination={{
                          pageSize: pageSize,
                          hideOnSinglePage: true,
                          size: 'large',
                          onChange: (page) => {
                            this.setState({
                              currentPage: page,
                              isMounted: false
                            });
                            setTimeout(() => {
                              this.setState({
                                isMounted: true
                              });
                            }, 0);
                          }
                        }}
            /></>)}
      </div>
    );
  }
}

export default AddMsisdnsFromFile;
